<template>
  <div id="app">
    <router-view/>

    <transition name="fade">
    <div class="welcome" v-if="isWelcome">
      <div class="youtube-video">
        <img src="./assets/img/logo.png" alt="logo">


        <iframe src="https://player.vimeo.com/video/648539755?h=a365c84166"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
<!--        <iframe src="https://www.youtube.com/embed/Tjdo1JFGcIc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>-->


        <div class="d-flex justify-content-center">

          <h1 id="clickid" class="font__futura-book clickhere" @click="closeVideo">Click here to continue</h1>
        </div>

<!--        <div class="d-flex justify-content-center">-->
<!--          <svg class="arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"-->
<!--               viewBox="0 0 24.28 17.85" style="enable-background:new 0 0 24.28 17.85;" xml:space="preserve">-->
<!--            <polygon id="svgfill" class="st7" points="17.13,12.76 12.14,7.77 7.15,12.76 5.8,11.42 12.14,5.08 18.47,11.42 "/>-->
<!--          </svg>-->

<!--        </div>-->



      </div>
    </div>
    </transition>

  </div>
</template>

<script>
  export default {
    components:{
    },
    computed: {
      isWelcome: function () {
        return this.$store.getters.openingVideo;
      }
    },
    data: function () {
      return {
      }
    },
    methods:{
      closeVideo(){
        this.$store.commit('setOpeningVideo', false);
      },
      scroll(id, offset) {
        this.active = id;
        const element = document.getElementById(id);
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },
    mounted() {
      let route = this.$route.path;
      if(route === '/playlist'){
        this.$store.commit('setOpeningVideo', false);
        this.scroll('block-portfolio', 150);
        this.scroll('block-portfolio-mobile', 80);
      }
      if(route === '/main'){
        this.$store.commit('setOpeningVideo', false);
      }
    }
  }
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.st7{
  fill:#aebfbd;
}

.clickhere{
  text-transform: uppercase;
  letter-spacing: 3pt;
  font-size: 13pt !important;
}


.arrow{
  margin-top: -10px;
  width: 30px;
}
iframe{
  width: 60vw;
  height: 60vh;
}
.youtube-video{
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.welcome {
  z-index: 100;
  position: fixed;
  background-color: #486864;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.welcome h1{
  color: #aebfbd;
  font-size: 20pt;
  margin-top: 30px;
  /*cursor: pointer;*/
}

#clickid:hover .arrow #svgfill{
  fill: white !important;
}

.welcome h1:hover{
  color: white;
}

.welcome img{
  width: 220px;
  position: absolute;
  right: 5vw;
  top: -70px;
}

@media screen and (max-width: 1300px) {
  .youtube-video{
    top: 60vh;
    /*display: none;*/
  }
}

@media screen and (max-width: 1024px) {
  .welcome{
    display: none;
  }
}

</style>

